export default "__VITE_ASSET__1abe721e__"